import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/role';

// GETALL
function getAll(state, action) {
  state.data = action.payload.data ? action.payload.data:[];
}

function conexionGetAll(state, action) {
  state.connection= action.payload.connection? action.payload.connection:false;
}

function errorGetAll(state, action) {
  state.error= action.payload.error ? action.payload.error:false;
  state.message= action.payload.message ? action.payload.message:"";
}

/**
 * Conexión
 */
const roleReducer = createSlice({
  name: 'role',
  initialState: initState,
  reducers: {
    // GETALL
    getAll,
    conexionGetAll,
    errorGetAll,
  },
});

export const roleActions = {
  ...roleReducer.actions,
};

export default roleReducer.reducer;
